import styled, { css, keyframes } from 'styled-components'
import { tokens } from 'styling/tokens'

const popIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

const itemSlide = keyframes`
  from {
    opacity: 0;
    transform: translateX(8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const ActionsMenuWrapper = styled.div`
  position: relative;
  display: inline-flex;
`

export const TriggerButton = styled.button<{ $open: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid ${tokens.accent.base};
  background: #ff99004d;
  color: ${tokens.accent.base};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(115%);
  }
`

export const BurgerWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 18px;
`

export const BurgerLine = styled.span<{ $open: boolean; $i: number }>`
  display: block;
  height: 2px;
  width: 18px;
  border-radius: 2px;
  background: currentColor;
  transform-origin: center;
  transition: transform 0.25s ease, opacity 0.2s ease;

  ${(props) =>
    props.$open &&
    props.$i === 0 &&
    css`
      transform: translateY(6px) rotate(45deg);
    `}

  ${(props) =>
    props.$open &&
    props.$i === 1 &&
    css`
      opacity: 0;
      transform: scaleX(0);
    `}

  ${(props) =>
    props.$open &&
    props.$i === 2 &&
    css`
      transform: translateY(-6px) rotate(-45deg);
    `}
`

export const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 12px;
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.raised};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  min-width: 11rem;
  z-index: 9999;
  animation: ${popIn} 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;
`

export const DropdownItem = styled.button<{ $orange?: boolean; $delay: number }>`
  height: 40px;
  width: 100%;
  border: none;
  border-radius: 10px;
  background: ${(props) => (props.$orange ? '#ff99004d' : 'transparent')};
  border: ${(props) => (props.$orange ? `1px solid ${tokens.accent.base}` : 'none')};
  color: ${(props) => (props.$orange ? tokens.accent.base : tokens.text.primary)};
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  padding: 0 0.875rem;
  cursor: pointer;
  white-space: nowrap;
  opacity: 0;
  animation: ${itemSlide} 0.2s ease forwards;
  animation-delay: ${(props) => props.$delay}ms;

  &:hover {
    filter: brightness(115%);
  }
`

export const ActionsMenuBreakpoint = styled.div<{ $breakpoint?: number }>`
  display: none;

  @media (max-width: ${(props) => props.$breakpoint ?? 900}px) {
    display: flex;
    align-items: center;
  }
`

export const HideOnBreakpoint = styled.div<{ $breakpoint?: number }>`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: ${(props) => props.$breakpoint ?? 900}px) {
    display: none;
  }
`
